import { ComponentType, useRef } from "react";
import { useFormikContext } from "formik";
import { TaskCreate } from "@common/contracts/task.contract";
import { PersistableView } from "@common/types/views/views";
import { withTaskViewEntities } from "./taskWorkflow";

interface WorkspaceTaskPreviewProps {
    Preview: ComponentType<{ viewConfig: PersistableView }>;
    isRemountedOnEntityChange?: boolean;
}

const WorkspaceTaskPreviewContent = ({
    Preview,
}: WorkspaceTaskPreviewProps) => {
    const { values } = useFormikContext<TaskCreate>();
    const mountedView = useRef(withTaskViewEntities(values)).current;

    return mountedView ? <Preview viewConfig={mountedView} /> : null;
};

export const WorkspaceTaskPreview = ({
    Preview,
    isRemountedOnEntityChange = true,
}: WorkspaceTaskPreviewProps) => {
    const { values } = useFormikContext<TaskCreate>();

    return (
        <WorkspaceTaskPreviewContent
            key={
                isRemountedOnEntityChange
                    ? (values.entityIds ?? []).join(",")
                    : undefined
            }
            Preview={Preview}
        />
    );
};
